// ---------------------------------------------
// STATUS CONSTANTS (integer enums)
// ---------------------------------------------
export const PROFILE_STATUS = {
  VACATION: 0,
  OPEN: 1,
  OUTSIDE_HOURS: 2,
  COMING_SOON: 3,
};

// ---------------------------------------------
// Convert 0–23 integer to 12-hour AM/PM
// ---------------------------------------------
export function convertToAmPm(hour) {
  if (hour === null || hour === undefined || isNaN(hour)) return "";

  const period = hour >= 12 ? "PM" : "AM";
  const normalizedHour = hour % 12 === 0 ? 12 : hour % 12;

  return `${normalizedHour} ${period}`;
}

// ---------------------------------------------
// Determine profile status using integer constants
// ---------------------------------------------
export function getProfileStatus(profile) {
  // 1. Vacation overrides everything
  if (profile.vacation) {
    return PROFILE_STATUS.VACATION;
  }

  const { startDate, startTime, endTime } = profile;

  // 3. Current hour (0–23)
  const now = new Date();
  const currentHour = now.getHours();

  // 🔑 Safely convert startDate
  const startDateObj = startDate ? new Date(startDate) : null;

  // 2. Coming soon (if startDate exists and is in the future)
  if (startDateObj && now < startDateObj) {
    return PROFILE_STATUS.COMING_SOON;
  }

  // 2. Validate hours
  if (
    startTime === undefined ||
    endTime === undefined ||
    isNaN(startTime) ||
    isNaN(endTime)
  ) {
    return PROFILE_STATUS.OUTSIDE_HOURS;
  }

  // 4. Adjust open time (your original logic)
  const open = startTime - 1;

  // 5. Same‑day schedule (e.g., 9 → 17)
  if (open < endTime) {
    return currentHour >= open && currentHour < endTime
      ? PROFILE_STATUS.OPEN
      : PROFILE_STATUS.OUTSIDE_HOURS;
  }

  // 6. Overnight schedule (e.g., 20 → 4)
  if (open > endTime) {
    return currentHour >= open || currentHour < endTime
      ? PROFILE_STATUS.OPEN
      : PROFILE_STATUS.OUTSIDE_HOURS;
  }

  // 7. startTime === endTime → closed all day
  return PROFILE_STATUS.OUTSIDE_HOURS;
}
